module.exports = __webpack_public_path__ + "img/axie-oh.4aae5690.png";